import { createFileRoute } from "@tanstack/react-router";

import { LoadingIcon } from "@web-app/components";
import { useApp } from "@web-app/hooks";
import AnalyticsPage from "@web-app/pages/analyticsPage";
import ChatEventsProvider from "@web-app/pages/chatPage/ChatEventsProvider";

export const Route = createFileRoute("/analytics/")({
  component: Analytics,
});

function Analytics() {
  const { sessionUser, isLoading, logout } = useApp();

  if (isLoading || !sessionUser) {
    return (
      <div className="h-screen w-screen grid place-content-center">
        <LoadingIcon className="w-8 h-8" />
      </div>
    );
  }

  if (!sessionUser) {
    return <div>Not authenticated</div>;
  }

  return (
    <ChatEventsProvider>
      <AnalyticsPage logout={logout} />
    </ChatEventsProvider>
  );
}
